import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { RowActionsWrapper } from "@msuite/ui/table";
import type { BookingsReviewListItem } from "@msuite/utils/types";

/** Props Interface */
interface BookingReviewRowActionsProps {
	booking: BookingsReviewListItem;
	onOpen: (booking: BookingsReviewListItem) => void;
}

/** Opens the record's bookings, where the host answers them. */
export function BookingReviewRowActions({ booking, onOpen }: BookingReviewRowActionsProps) {
	/** Render */
	return (
		<RowActionsWrapper>
			<Button
				size="xxs"
				variant="ghost"
				icon={<Icon name="ArrowRight" />}
				onClick={() => onOpen(booking)}
				data-cy="booking-review-open"
			/>
		</RowActionsWrapper>
	);
}
